import React, { useEffect, useState } from "react";
import AnnouncementForm from "./AnnouncementForm";
import "./announcement.css";

import {
  fetchAllAnnouncements,
  deleteAnnouncement as deleteAnnouncementService,
  toggleAnnouncementStatus
} from "./adminAnnouncementService";


const AdminAnnouncementPage = () => {

  const [announcements, setAnnouncements] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    loadAnnouncements();
  }, []);


  /**
   * Load all announcements
   */
  const loadAnnouncements = async () => {

    setLoading(true);

    const response = await fetchAllAnnouncements();

    if (response.status === 200) {
      setAnnouncements(response.data);
    } else {
      alert(response.message || "Failed to load announcements");
    }

    setLoading(false);

  };


  /**
   * Delete announcement
   */
  const deleteAnnouncement = async (id) => {

    if (!window.confirm("Delete this announcement?")) return;

    const response = await deleteAnnouncementService(id);

    if (response.status === 200 || response.status === 204) {

      loadAnnouncements();

    } else {

      alert(response.message || "Delete failed");

    }

  };


  /**
   * Enable / Disable announcement
   */
  const toggleEnable = async (id, currentEnabled) => {

    const response = await toggleAnnouncementStatus(
      id,
      !currentEnabled
    );

    if (response.status === 200) {

      loadAnnouncements();

    } else {

      alert(response.message || "Update failed");

    }

  };


  /**
   * Edit announcement
   */
  const editAnnouncement = (announcement) => {

    setEditing(announcement);
    setShowForm(true);

  };


  /**
   * Create new announcement
   */
  const newAnnouncement = () => {

    setEditing(null);
    setShowForm(true);

  };


  /**
   * After save refresh list
   */
  const onFormSaved = () => {

    setShowForm(false);
    loadAnnouncements();

  };


  return (

    <div className="admin-container">

      <div className="admin-header">

        <h2>Announcement Management</h2>

        <button onClick={newAnnouncement}>
          + New Announcement
        </button>

      </div>


      {showForm && (

        <AnnouncementForm
          announcement={editing}
          onSaved={onFormSaved}
          onCancel={() => setShowForm(false)}
        />

      )}


      {loading ? (

        <p>Loading announcements...</p>

      ) : (

        <table className="announcement-table">

          <thead>

            <tr>
              <th>Priority</th>
              <th>Message</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>

          </thead>

          <tbody>

            {announcements.length === 0 ? (

              <tr>
                <td colSpan="4">
                  No announcements found
                </td>
              </tr>

            ) : (

              announcements.map((a) => (

                <tr key={a.id}>

                  <td>{a.priority}</td>

                  <td>{a.message}</td>

                  <td>

                    <label className="switch">

                      <input
                        type="checkbox"
                        checked={a.enabled}
                        onChange={() =>
                          toggleEnable(a.id, a.enabled)
                        }
                      />

                      <span className="slider"></span>

                    </label>

                  </td>

                  <td>

                    <button
                      onClick={() =>
                        editAnnouncement(a)
                      }
                    >
                      Edit
                    </button>

                    <button
                      className="delete-btn"
                      onClick={() =>
                        deleteAnnouncement(a.id)
                      }
                    >
                      Delete
                    </button>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      )}

    </div>

  );

};

export default AdminAnnouncementPage;
